var map = {
	"./logo_pink": "./app/javascript/images/logo_pink.svg",
	"./logo_pink.svg": "./app/javascript/images/logo_pink.svg",
	"./vuma-logo": "./app/javascript/images/vuma-logo.png",
	"./vuma-logo.png": "./app/javascript/images/vuma-logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";